import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    // 有Tab的router，有commonLayer
    {
        path: '/',
        name: 'CommonLayerLayout',
        component: () => import('../layout/CommonLayerLayout.vue'),
        children: [{
            path: '/',
            name: 'TabLayout',
            component: () => import('../layout/TabLayout.vue'),
            children: [{
                path: '/me',
                name: 'Me',
                component: () => import('../views/Me.vue')
            }, {
                path: '/home',
                name: 'Home',
                component: () => import('../views/Home.vue')
            }, {
                path: '/simple-home',
                name: 'SimpleHome',
                component: () => import('../views/SimpleHome.vue')
            }, {
                path: '/starbucks-home',
                name: 'StarbucksHome',
                component: () => import('../views/StarbucksHome.vue')
            }]
        },
        // 无Tab,有commonLayer
        {
            path: '/nine',
            name: 'Nine',
            component: () => import('../views/NinePointNine.vue')
        },
        {
            path: '/form',
            name: 'Form',
            component: () => import('../views/Form.vue')
        },
        {
            path: "/coupon-list",
            name: "CouponList",
            component: () => import("../views/CouponList.vue")
        },
        {
            path: '/sku/:goodsId',
            name: 'Sku',
            component: () => import('../views/Sku.vue'),
        },
        {
            path: '/submit-order',
            name: 'SubmitOrder',
            component: () => import('../views/SubmitOrder.vue')
        },
        {
            path: '/result/:order_no',
            name: 'OrderPaymentResult',
            component: () => import('../views/OrderPaymentResult.vue')
        },
        {
            path: '/order-list',
            name: 'OrderList',
            component: () => import('../views/OrderList.vue')
        },
        {
            path: '/order/:order_no',
            name: 'Order',
            component: () => import('../views/OrderDetail.vue')
        }, {
            path: '/goods',
            name: 'Goods',
            component: () => import('../views/Goods.vue')
        }, {
            path: '/ticket/:order_no',
            name: 'Ticket',
            component: () => import('../views/Ticket.vue')
        }, {
            path: '/post-sale',
            name: 'PostSale',
            component: () => import('../views/PostSale.vue')
        }, {
            path: '/wechat-red-packet',
            name: 'WechatRedPacket',
            component: () => import('../views/WechatRedPacket.vue')
        }]
    },
    // 无Tab无CommonLayer
    {
        path: '/authorize',
        name: 'WechatPreAuthorize',
        component: () => import('../views/WechatPreAuthorize.vue')
    }, {
        // movie 登录页
        path: '/movie/login',
        name: 'MovieLogin',
        component: () => import('../views/movie/MovieLogin.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
